<!-- ============================================================= -->
<!-- NEW DESIGN — candidate card  (.gjcc-*)                        -->
<!-- Used by the /talents listing.                                 -->
<!-- Mirrors the job card; differs on:                             -->
<!--   • title = role (jobTitle) — candidate name is NEVER shown   -->
<!--   • status = Available / Unavailable                          -->
<!--   • CTA   = Invite                                            -->
<!-- ============================================================= -->
<div class="gjcc-card"
     [class.gjcc-card--active]="selectedItem == passValues?.candidateId"
     [class.gjcc-card--featured]="passValues?.isFeatured"
     [class.gjcc-card--disabled]="!passValues?.availability">

  <a class="gjcc-cardlink" rel="noopener noreferrer"
     [routerLink]="getRouteURL(passValues)" [queryParams]="currentQueryParams"
     (click)="candidateData.setData(passValues)" (click)="setMetaTags(passValues)">

    <div class="gjcc-top">
      <div class="gjcc-head">
        <!-- Candidate name shown but visually masked (privacy on public page).
             aria-hidden + user-select:none keep it out of a11y/copy. -->
        <div class="gjcc-name-masked" aria-hidden="true">
          {{ passValues?.firstName }} {{ passValues?.lastName }}
        </div>
        <div class="gjcc-title" [title]="passValues?.jobTitle">{{ passValues?.jobTitle || '-' }}</div>
        <div class="gjcc-sub" *ngIf="passValues?.showClientName" [title]="passValues?.clientName">
          {{ (passValues?.clientName | truncate:24) || '-' }}
        </div>
      </div>
      <div class="gjcc-top-right">
        <span class="gjcc-status" [ngClass]="'gjcc-status--' + getStatusClass(passValues?.status)">
          {{ getStatusLabel(passValues?.status) || '-' }}
        </span>
        <span class="gjcc-tag gjcc-tag--hot" *ngIf="passValues?.isFeatured">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M13.5 0c.6 0 1.3 1.6 1.5 3 .3 1.8.1 3-1 4.3 1.5-.6 3-.5 4-.3 1.4.3 2.5 1.4 2.6 2.9.1 1.5-.8 2.7-2 3.1.8.7 1.4 1.7 1.4 3 0 2.8-3.1 5.2-7 5.2-3.5 0-7-2.2-7-5.7 0-1.8 1-3.5 2-4.7C7.8 9.6 7 8.4 7 6.7 7 4 9.7 1.8 13.5 0z"/>
          </svg>
          Hot
        </span>
      </div>
    </div>

    <div class="gjcc-meta">
      <div class="gjcc-meta-row" [title]="passValues?.city + ', ' + passValues?.state">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
        </svg>
        <ng-container *ngIf="passValues?.city || passValues?.state; else candNoLoc">
          {{ passValues?.city }}<span *ngIf="passValues?.state">, {{ passValues?.state }}</span>
        </ng-container>
        <ng-template #candNoLoc>-</ng-template>
      </div>
      <div class="gjcc-meta-row" [title]="passValues?.engagementType">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
        {{ passValues?.engagementType || '-' }}<span *ngIf="passValues?.engagementType && passValues?.remoteWork"> · Remote</span>
      </div>
      <div class="gjcc-meta-row">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
        {{ rateText || '-' }}
      </div>
    </div>
  </a>

  <div class="gjcc-footer">
    <span class="gjcc-stat">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
      </svg>
      {{ passValues?.viewedByCount || 0 }} {{ (passValues?.viewedByCount || 0) > 1 ? 'views' : 'view' }}
    </span>
    <a class="gjcc-invite"
       [class.gjcc-invite--disabled]="passValues?.status !== 'ACTIVE' || !passValues?.availability"
       href="{{ getLoginParams(passValues) }}" target="_blank" rel="noopener noreferrer">
      {{ (passValues?.status !== 'ACTIVE' || !passValues?.availability) ? 'N/A' : 'Invite' }}
    </a>
  </div>
</div>
